import React from "react";
import Icon from "components/AppIcon";

const AdminTable = ({ admins, onEdit, onDeactivate, onDelete, language }) => {
  const permissions = JSON.parse(localStorage.getItem("permissions"));

  const deleteUserExists = permissions.some(
    (permission) => permission.name === "delete_user"
  );

  const updateUserExists = permissions.some(
    (permission) => permission.name === "update_user"
  );
  const translations = {
    en: {
      name: "Name",
      email: "Email",
      role: "Role",
      lastLogin: "Last Login",
      status: "Status",
      actions: "Actions",
      active: "Active",
      inactive: "Inactive",
      admin: "Admin",
      staff: "Staff",
      edit: "Edit",
      deactivate: "Deactivate",
      activate: "Activate",
      delete: "Delete",
      never: "Never",
    },
    ar: {
      name: "الاسم",
      email: "البريد الإلكتروني",
      role: "الدور",
      lastLogin: "آخر تسجيل دخول",
      status: "الحالة",
      actions: "الإجراءات",
      active: "نشط",
      inactive: "غير نشط",
      admin: "مشرف",
      staff: "موظف",
      edit: "تعديل",
      deactivate: "إلغاء التفعيل",
      activate: "تفعيل",
      delete: "حذف",
      never: "أبداً",
    },
  };

  const t = translations[language];

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              {t.name}
            </th>
            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              {t.email}
            </th>
            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              {t.role}
            </th>

            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              {t.status}
            </th>
            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              {t.actions}
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {admins?.map((admin) => (
            <tr key={admin.id} className="hover:bg-gray-50">
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                    <Icon name="User" size={20} className="text-green-600" />
                  </div>
                  <div className="ml-4">
                    <div className="text-sm font-medium text-gray-900">
                      {admin.name}
                    </div>
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="text-sm text-gray-900">{admin.email}</div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span
                  className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                    admin.role === "Admin"
                      ? "bg-green-100 text-green-800"
                      : "bg-blue-100 text-blue-800"
                  }`}
                >
                  {admin?.role?.name}
                </span>
              </td>

              <td className="px-6 py-4 whitespace-nowrap">
                <span
                  className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                    admin.activation_status === "active"
                      ? "bg-green-100 text-green-800"
                      : "bg-red-100 text-red-800"
                  }`}
                >
                  {admin.activation_status == "active" ? t.active : t.inactive}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                <div className="flex space-x-2">
                  {updateUserExists && (
                    <button
                      onClick={() => onEdit(admin)}
                      className="text-green-600 hover:text-green-900 p-1 rounded hover:bg-green-50"
                      title={t.edit}
                    >
                      <Icon name="Edit" size={16} />
                    </button>
                  )}
                  {/* <button
                    onClick={() => onDeactivate(admin)}
                    className={`p-1 rounded ${
                      admin.activation_status === 'active' ?'text-yellow-600 hover:text-yellow-900 hover:bg-yellow-50' :'text-green-600 hover:text-green-900 hover:bg-green-50'
                    }`}
                    title={admin.activation_status === 'active' ? t.deactivate : t.activate}
                  >
                    <Icon name={admin.activation_status === 'active' ? 'UserX' : 'UserCheck'} size={16} />
                  </button>*/}
                  {deleteUserExists && (
                    <button
                      onClick={() => onDelete(admin)}
                      className="text-red-600 hover:text-red-900 p-1 rounded hover:bg-red-50"
                      title={t.delete}
                    >
                      <Icon name="Trash2" size={16} />
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminTable;
